import { apiClient, toServiceError } from '@/services/http/client'

export interface SupportNotification {
  id: string
  event_type: 'support_access_activated' | 'support_access_revoked'
  payload: { support_session_id: string; ticket: string; expires_at?: string }
  created_at: string
}

export async function listSupportNotifications(): Promise<SupportNotification[]> {
  try { return (await apiClient.get<SupportNotification[]>('/support-notifications', { params: { limit: 10 } })).data }
  catch (error) { throw toServiceError(error) }
}
